import { markupTemplateLang } from "./shared"

markupTemplateLang("liquid", {
	block: ["{% comment %}", "{% endcomment %}"],
})
